import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as e, isNone as t } from "../../../core/maybe.js";

var i = /*#__PURE__*/function () {
  function i(e, t, _i) {
    _classCallCheck(this, i);

    this.pixelBlock = e, this.extent = t, this.originalPixelBlock = _i;
  }

  _createClass(i, [{
    key: "width",
    get: function get() {
      return e(this.pixelBlock) ? this.pixelBlock.width : 0;
    }
  }, {
    key: "height",
    get: function get() {
      return e(this.pixelBlock) ? this.pixelBlock.height : 0;
    }
  }, {
    key: "render",
    value: function render(e) {
      var _i2 = this.pixelBlock;
      if (t(_i2)) return;
      var l = this.filter({
        pixelBlock: _i2
      });
      if (t(l.pixelBlock)) return;
      var r = l.pixelBlock.getAsRGBA(),
          o = e.createImageData(l.pixelBlock.width, l.pixelBlock.height);
      o.data.set(r), e.putImageData(o, 0, 0);
    }
  }, {
    key: "getRenderedRasterPixels",
    value: function getRenderedRasterPixels() {
      var e = this.filter({
        pixelBlock: this.pixelBlock
      });
      return t(e.pixelBlock) ? null : {
        width: e.pixelBlock.width,
        height: e.pixelBlock.height,
        renderedRasterPixels: new Uint8Array(e.pixelBlock.getAsRGBA().buffer)
      };
    }
  }]);

  return i;
}();

export { i as default };